import { LEARNING_MODE } from 'Context/ClassroomContext';
/**
/**
 * Calculates the learning mode progress based on the provided subsections.
 *
 * @param {Array} subsections - An array of course's subsection.
 * @param {string} currentLearningMode - An string of currentLearningMode.
 * @returns {number} The percentage of completed subsections in the learning mode, rounded to the nearest integer.
 */
export const calculateLearningModeProgress = (subsections, currentLearningMode) => {
  if (currentLearningMode === LEARNING_MODE.DEFAULT) return 0;

  const allSubsectionsInCurrentMode = subsections.filter((subsection) =>
    subsection.learningModes.includes(currentLearningMode)
  );

  const completedSubsectionsInCurrentMode = subsections.filter(
    (subsection) =>
      subsection.complete && subsection.completedLearningModeList.includes(currentLearningMode)
  );

  if (completedSubsectionsInCurrentMode.length === 0 || allSubsectionsInCurrentMode.length === 0) {
    return 0;
  } else {
    const progressPercentage = Math.floor(
      (completedSubsectionsInCurrentMode.length * 100) / allSubsectionsInCurrentMode.length
    );

    return progressPercentage;
  }
};
